module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/content#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AY")]), _vm._v(" 21, 2009"), _c('br'), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ORK")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ITY")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D")])]), _vm._v("avid Swisher spun the track ball of his BlackBerry until he found the e-mail from the CFO of one of his clients. The guy wanted to find a time to come down from Hartford to talk about a debt financing. Routine stuff, the kind of business he saved for his ride home. He thumb-typed a reply while the Town Car jerked up Park Avenue in stop-and-go traffic.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A chime announced the arrival of a new e-mail. It was from his wife: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ve got a surprise for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He texted back: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Excellent! Can’t wait.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Outside the window of his limo the sidewalks were busy with New Yorkers intoxicated with the first blush of spring weather. The bleached evening light and the warm weightless air quickened their steps and lifted their spirits. Men with jackets on their thumbs and rolled-up sleeves felt the breeze on their bare forearms, and women in short diaphanous skirts felt it against their thighs. The sap was rising, for sure. Hormones, locked-up like ships trapped in arctic ice, started flowing free in the spring thaw. There would be action tonight in the city. From a high floor of an apartment tower, someone was exuberantly playing Stravinsky’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rite of Spring")]), _vm._v(" on a stereo, and the notes wafted down from open windows and fused with the cacophony of the city.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All this was unnoticed by David, who concentrated on "), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("his little glowing LCD screen. And he too was unnoticed, veiled by a tinted window—a thirty-six-year-old investment banker, plainly affluent, with a good head of hair, a lightweight wool suit from Barneys, and a scowl plastered on from a day that had done nothing for his career, his ego, or his bank account.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The taxi stopped at his building on Park and 81st, and walking the fourteen feet from the curb to the door he realized the weather was pleasant. By way of celebration he breathed one full measure of atmosphere into his lungs then managed to smile at his doorman. “How’re you doing, Pete?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Just fine, Mr. Swisher. How’d the markets do today?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fucking bloodbath.” He swept past. “Keep your money under your mattress.” Their little joke.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His nine room co-op on a high floor cost him a shade under four and three-quarters when he bought it shortly after 9/11. A steal. The markets were nervous, the sellers were nervous, even though this was a gem, a white-glove building, a prewar with twelve-foot ceilings, eat-in kitchen, and a working fireplace. On Park! He liked to buy in at the bottom of a market, any market. This way he got more space than a childless couple needed, but it was a trophy that got wows from his family, which always made him feel pretty damn good. Besides, it was worth well over seven-five now, even in a fire sale, so all in all a great deal for Swish, he reminded himself frequently.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The mailbox was empty. He called back over his shoulder, “Hey, Pete, did my wife come in already?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“About ten minutes ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That was the surprise.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Her briefcase was on the hall table, sitting on a pile of mail. He closed the door noiselessly and tried to tiptoe, maybe sneak up behind her, cup her breasts in his hands ")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("and press up against her rump. His idea of fun. The Italian marble blew his plan when even his supple dress loafers tapped and echoed enough to betray him.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“David? That you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah. You’re home early,” he called. “How come?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From the kitchen: “My deposition got pushed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The dog heard his voice and ran at full throttle from a guest bedroom at the far end of the apartment, its little paws skidding on the marble, sending the poodle crashing into the wall like a hockey player.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Bloomberg!” David shouted. “How’s my little baby!” He put his case down and picked up the white fluff ball, who licked at his face with its pink piston tongue while furiously wagging its bobbed tail. “Don’t pee on Daddy’s tie! Don’t you do that. Good boy, good boy. Honey, was Bloomie walked?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Pete said Ricardo walked him at four.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He put the dog down and went for the mail, sorting it into piles in his obsessive kind of way. Bills. Statements. Junk. Personal. His catalogues. Her catalogues. Magazines. Postcard?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A plain white postcard with his name and address printed in black type. He flipped it over.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a typed date: May 22, 2009. And next to it an image that instantly disturbed him: the unmistakable outline of a coffin, about an inch tall, hand-drawn in ink.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Helen! Did you see this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His wife came into the hall, high heels clipping on the stone, perfectly turned out in a pale turquoise Armani suit with a double strand of cultured pearls resting just above a hint of cleavage, her matching pearl earrings playing peekaboo under salon-styled hair. A handsome-looking woman, anyone would agree.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“See what?” she asked.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“This.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She looked it over. “Who sent it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“There’s no return address,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s postmarked Las Vegas. Who do you know in Vegas?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Christ, I don’t know. I’ve done business there—I can’t think of anyone offhand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Maybe it’s a promotion for something, like a teaser ad,” she suggested, handing it back to him. “Tomorrow there’ll be something else in the mail that’ll explain it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He bought it. She was smart and usually figured things out. But still. “It’s in bad taste. Fucking coffin. I mean, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t let it put you in a mood. We’re both home at a civilized time. How great is that? Want to go to Tutti’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He put the postcard onto the junk stack and grabbed her ass. “Before or after we fool around?” he asked, hoping the answer was “After.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The postcard bugged David on and off all evening, though he didn’t bring it up again. He thought about it while they waited for dessert, he thought about when they got home right after he came inside her, he thought about it when he took Bloomie for a quick pee outside the building before they turned in for the night. And it was the last thing he thought about before he fell asleep as Helen read beside him, the bluish glow of her clip-on book light faintly illuminating the black edges of the master bedroom. Coffins bothered the hell out of him. When he was nine, his five-year-old brother died of a Wilms’ tumor, and Barry’s little polished mahogany coffin—sitting on a pedestal in the memorial chapel—haunted him still. Whoever sent that postcard was a shithead, plain and simple.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("He killed the alarm clock about fifteen minutes before it ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("would have sounded off at 5:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M")]), _vm._v(". The poodle jumped off the bed and started doing its nutty first-thing-in-the-morning running in circles routine.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay, okay,” he whispered. “I’m coming!” Helen slept on. Bankers went into the office hours before lawyers, so the morning dog walk was his.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A few minutes later David said hello to the night doorman as Bloomberg tugged him on his leash into the predawn chill. He zipped his track suit top all the way to his throat before heading north for their usual circuit—up to 82nd, where the dog invariably did most of his business, east to Lex, hit the early-bird Starbucks, then back to 81st and home. Park Avenue was seldom empty, and this morning a fair number of cabs and delivery trucks rolled by.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mind was perpetually motoring; he found the concept of “chilling” ludicrous. He was always working some angle, but as he approached 82nd Street, he wasn’t centered on any particular topic, more an unedited hodgepodge of work-related to-dos. The postcard, thankfully, was forgotten. Making the turn onto the ominously dark tree-lined street, his city-slicker survival skills almost made him alter his route—he briefly considered carrying on up to 83rd—but his trading-floor macho wouldn’t let him wimp out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instead he crossed over to the north side of 82nd Street so he could keep an eye on the dark-skinned kid milling on the sidewalk about a third of the way down the block. If the kid crossed the street too, he’d know he was in trouble and he would pick up Bloomie and make a run for it. He had run track in school. He was still fast from pickup B-ball. His Nike’s were laced nice and tight. So, fuck it, worst case scenario, he’d still be okay.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("The kid started walking in his direction on the opposite side of the block, a lanky fellow with a hoodie up so David couldn’t see his eyes. He hoped a car would come along or ")]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("another pedestrian, but the street stayed quiet, two men and a dog, so still, he could hear the kid’s new sneakers squeaking on the pavement. The brownstones were dark, their occupants dreaming. The only doorman building was nearer to Lexington. His heart rate ramped up as they drew level. No eye contact. No eye contact. He kept going. The kid kept going, and the gap between them widened.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("He allowed himself an over-the-shoulder glance and exhaled when he saw the kid turning onto Park, disappearing around the corner. I’m a fucking wuss, he thought. And a prejudiced one too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Halfway down the block, Bloomie sniffed at his favorite spot and started to squat. David couldn’t understand why he hadn’t heard the kid until he was almost on him. Maybe he’d been distracted, thinking about his first appointment with the head of capital markets, or watching the dog find its spot, or remembering the way Helen had flung off her bra last night, or maybe the kid had made an art of urban stealth running. But it was all academic.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("David was punched in the temple and went down hard on his knees, momentarily fascinated, more than afraid, by the unexpected violence. The punch made his head soupy. He watched Bloomie finish his poop. He heard something about money and felt hands going through his pockets. He saw a blade near his face. He felt his watch slipping off, then his ring. Then he remembered the postcard, that goddamned postcard, and heard himself asking, “Did you send it?” He thought he heard the kid answer, “Yeah, I sent it, motherfucker.”")])])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b208a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0